import React from "react";
// import { useNavigate } from "react-router-dom";
import 'katex/dist/katex.min.css'
import Markdown from "../../../../common/Markdown";
import NoData from "../../components/NoData";
import { MdEdit } from "react-icons/md";

export default function ModelCard({ modelCard, canEdit }) {
  // const navigate = useNavigate();

  // const handleMore = (e) => {
  //   navigate(`/m2d/projects/${e.target.id}`);
  // };

  return (
    <div className="model-card-content">
      {modelCard ?
        <div className="markdown">
          <div className="markdown-toolbar">
            <div className="title">Model Card</div>
            {canEdit && <div className="edit">
              <MdEdit />
            </div>}
          </div>
          <Markdown>{modelCard}</Markdown>
        </div>
        :
        <NoData info="No model card" />
      }
{/* 
      <div
        className="model-pg-head"
        hidden={
          model.m2dProjects && model.m2dProjects.length > 0 ? false : true
        }
      >
        Used In
      </div>
      {model.m2dProjects && model.m2dProjects.length > 0
        ? model.m2dProjects.map((project) => {
          return (
            <div className="model-pg-projects" key={`projects-${project.id}`}>
              <div className="model-pg-project-title">{project.title}</div>
              <div className="model-pg-project-info">
                <div className="model-pg-project-desc">
                  - {project.description}
                </div>
                <div
                  className="model-pg-project-more-btn"
                  id={project.id}
                  onClick={handleMore}
                >
                  More
                </div>
              </div>
            </div>
          );
        })
        : null} */}
    </div>
  );
}
